<template>
  <div class="about-page-wrapper">
    <!-- 英雄区域 -->
    <HeroSection />
    
    <!-- 关于我们 -->
    <AboutSection 
      :image-data="imageData" 
      @show-modal="showModal"
    />
    
    <!-- 业务矩阵 -->
    <BusinessMatrix />
    
    <!-- 核心价值 -->
    <CoreValues />

    <!-- 模态框 -->
    <ImageModal 
      v-if="isModalVisible"
      :image-src="imageData.highQuality"
      @close="closeModal"
    />
  </div>
</template>

<script>
import HeroSection from '@/components/HeroSection.vue';
import AboutSection from '@/components/AboutSection.vue';
import BusinessMatrix from '@/components/BusinessMatrix.vue';
import CoreValues from '@/components/CoreValues.vue';
import ImageModal from '@/components/ImageModal.vue';

export default {
  name: 'AboutPage',
  components: {
    HeroSection,
    AboutSection,
    BusinessMatrix,
    CoreValues,
    ImageModal
  },
  data() {
    return {
      isModalVisible: false,
      imageData: {
        lowQuality: 'https://pcctc-website.oss-cn-beijing.aliyuncs.com/about-image-low-quality.png',
        highQuality: 'https://pcctc-website.oss-cn-beijing.aliyuncs.com/about-image.png'
      }
    };
  },
  methods: {
    showModal() {
      this.isModalVisible = true;
      document.body.style.overflow = 'hidden';
    },
    closeModal() {
      this.isModalVisible = false;
      document.body.style.overflow = '';
    }
  }
};
</script>

<style scoped>
.about-page-wrapper {
  padding-top: 20px;
  min-height: 100vh;
  overflow-x: hidden;
  --primary-color: #667eea;
  --secondary-color: #764ba2;
  --accent-color: rgba(255, 255, 255, 0.1);
  --text-color: white;
  --border-color: rgba(255, 255, 255, 0.2);
}

/* 通用页面样式 */
:deep(.page-section) {
  min-height: 100vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  padding: 40px 20px;
  box-sizing: border-box;
  background: linear-gradient(135deg, var(--primary-color) 0%, var(--secondary-color) 100%);
}

:deep(.page-container) {
  max-width: 1200px;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0 20px;
  box-sizing: border-box;
}

:deep(.page-title) {
  text-align: center;
  margin-bottom: 40px;
  position: relative;
}

:deep(.title-highlight) {
  display: block;
  font-size: clamp(2rem, 4vw, 2.8rem);
  font-weight: 700;
  margin-bottom: 8px;
  background: linear-gradient(135deg, #ffffff 0%, #f0f8ff 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

:deep(.title-subtitle) {
  display: block;
  font-size: 0.9rem;
  opacity: 0.7;
  text-transform: uppercase;
  letter-spacing: 2px;
  font-weight: 300;
  color: var(--text-color);
}

/* 统一卡片样式 */
:deep(.floating-card),
:deep(.scope-module-compact),
:deep(.value-card-compact),
:deep(.highlight-item) {
  background: var(--accent-color);
  backdrop-filter: blur(10px);
  border: 1px solid var(--border-color);
  border-radius: 16px;
  transition: all 0.3s ease;
}

:deep(.floating-card):hover,
:deep(.scope-module-compact):hover,
:deep(.value-card-compact):hover,
:deep(.highlight-item):hover {
  transform: translateY(-5px);
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.2);
}

/* 响应式调整 */
@media (max-width: 768px) {
  .about-page-wrapper {
    padding-top: 50px;
  }
  
  :deep(.page-section) {
    padding: 30px 15px;
  }
  
  :deep(.page-container) {
    padding: 0 15px;
  }
}
</style>